


































































































































































































































































































































































































































































































































































































































































































































































































import {
  ref,
  defineComponent,
  computed,
  watch,
  reactive,
  watchEffect,
  Ref,
} from "@vue/composition-api";
import Vue from "vue";
import Component from "vue-class-component";
import router from "../router/index";
import store from "../store/index";
import { Request, AXIOS } from "@/utility/api";
import { DateTimeFormat } from "vue-i18n";
import { DateUtils } from "@/utility/utils";

@Component
export default class extends Vue {
  //宣告變數
  soldToIdList: SelectItem[] = [];
  quoteStatusList: SelectItem[] = [];
  cyntecUserList: SelectItem[] = [];
  isValidList: SelectItem[] = [];
  //quotationNoList: SelectItem[] = [];
  tableDatas: TableItem[] = [];
  tableHeaders: TableColumn[] = [];
  tableProductDatas: ProductTableItem[] = [];
  tableProductHeaders: TableColumn[] = [];
  tableCreateProductHeaders: TableColumn[] = [];
  tableEditProductHeaders: TableColumn[] = [];
  pricingDateFm = false;
  pricingDateTo = false;
  modifiedDateFm = false;
  modifiedDateTo = false;
  creationDateFm = false;
  creationDateTo = false;
  btnToShow = true;
  isLoading = true;
  //訊息的彈跳視窗
  infoDialog = false;
  infoString = "";
  //搜尋
  filterSoldToId = "";
  filterQuotationNo = "";
  filterCustomerName = "";
  filterProjectNo = "";
  filterQuoteStatus = "";
  filterCyntecUser = "";
  filterPricingDateFm = "";
  filterPricingDateTo = "";
  filterModifiedDateFm = "";
  filterModifiedDateTo = "";
  filterCreationDateFm = "";
  filterCreationDateTo = "";
  filterIsValid = "";
  filterProductId = "";

  //#region create form 宣告
  createDialog = false;
  createProjectNoList: SelectItem[] = [];
  createProjectId = "";
  createProjectNo = "";
  createSoldToId = "";
  createProjectName = "";
  createSegName = "";
  createAppName = "";
  createMassProdPeriod = "";
  createCustomerName = "";
  createSubCustomerName = "";
  createEndCustomerName = "";
  createProductId = "";
  //#endregion

  //#region edit form 宣告
  editDialog = false;
  editId = 0;
  editQuotationNo = "";
  editProjectNo = "";
  editProjectName = "";
  editSoldToId = "";
  editSegName = "";
  editAppName = "";
  editMassProdPeriod = "";
  editCustomerName = "";
  editEndCustomerName = "";
  editSubCustomerName = "";
  editCyntecUserName = "";
  editProductId = "";
  editProducIndex = 0;
  editIndex = 0;
  editShow = false;
  btnEditUpdateHidden = true;
  btnEditAddHidden = true;
  btnEditCancelHidden = true;

  RowDelet: number[] = [];
  //#endregion

  change(item: any) {
    this.ShowMessage(item, "info");
  }

  //#region Table欄位Sorting
  customSort(items, index, isDesc) {
    items.sort((a, b) => {
      if (index.length > 0) {
        let pAString: string =
          a[
            index[0].substring(0, 1).toUpperCase() +
              index[0].substring(1, index[0].length)
          ];
        let pBString: string =
          b[
            index[0].substring(0, 1).toUpperCase() +
              index[0].substring(1, index[0].length)
          ];

        if (!isDesc[0]) {
          return pAString.toLowerCase().localeCompare(pBString.toLowerCase());
        } else {
          return pBString.toLowerCase().localeCompare(pAString.toLowerCase());
        }
      }
    });
    return items;
  }
  //#endregion

  //#region 進入頁面Mounted
  mounted() {
    this.isLoading = true;
    this.GetSoldToIdList();
    //this.GetQuotationNoList();
    this.GetQuoteStatusList();
    this.GetCyntecUserList();
    this.GetIsValidList();
    this.GetCreateOrEditFormList();
    this.SetProductHeaders();
    this.SetHeaders();
    this.SetTable();
  }
  //#endregion

  //#region 設定日期格式
  setDateFormat(dateString: string) {
    return DateUtils.dateFormat(dateString);
  }
  //#endregion

  //#region 取得SoldToIDList
  async GetSoldToIdList() {
    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynSoldToIds/GetByUserId",
      null
    ).catch((error) => {
      if (error.response == null) {
        //console.log(error);
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });

    if (response.data.success && response.data.result.items.length > 0) {
      for (let item of response.data.result.items) {
        let newItem: SelectItem = new SelectItem();
        newItem.text = item.cynSoldToId.soldToId;
        newItem.value = item.cynSoldToId.soldToId;
        this.soldToIdList.push(newItem);
      }
    }
  }
  //#endregion

  //#region 取得QuoteStatusList
  async GetQuoteStatusList() {
    this.quoteStatusList = [];
    let item1: SelectItem = {
      text: "Request",
      value: "1",
      disabled: false,
      divider: false,
      header: "",
    };
    let item2: SelectItem = {
      text: "Pending",
      value: "2",
      disabled: false,
      divider: false,
      header: "",
    };
    let item3: SelectItem = {
      text: "Bidding",
      value: "3",
      disabled: false,
      divider: false,
      header: "",
    };
    let item4: SelectItem = {
      text: "Accepted",
      value: "4",
      disabled: false,
      divider: false,
      header: "",
    };
    this.quoteStatusList.push(item1);
    this.quoteStatusList.push(item2);
    this.quoteStatusList.push(item3);
    this.quoteStatusList.push(item4);
  }
  //#endregion

  //#region 取得CyntecUserList
  async GetCyntecUserList() {
    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynUsers/GetCyntecUserList",
      null
    ).catch((error) => {
      if (error.response == null) {
        //console.log(error);
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success && response.data.result.items.length > 0) {
      for (let item of response.data.result.items) {
        let newItem: SelectItem = new SelectItem();
        newItem.text = item.userName;
        newItem.value = item.userId;
        this.cyntecUserList.push(newItem);
      }
    }
  }
  //#endregion

  //#region 取得QuoteStatusList
  async GetIsValidList() {
    this.isValidList = [];
    let item1: SelectItem = {
      text: "Valid",
      value: "Y",
      disabled: false,
      divider: false,
      header: "",
    };
    let item2: SelectItem = {
      text: "InValid",
      value: "N",
      disabled: false,
      divider: false,
      header: "",
    };
    this.isValidList.push(item1);
    this.isValidList.push(item2);
  }
  //#endregion

  //#region 取得QuotationList
  /*async GetQuotationNoList() {
    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetQuotationListByUserId?Sorting=QuotationNo",
      null
    ).catch((error) => {
      if (error.response == null) {
        //console.log(error);
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success && response.data.result.items.length > 0) {
      for (let item of response.data.result.items) {
        let newItem: SelectItem = new SelectItem();
        newItem.text = item.quotationNo;
        newItem.value = item.quotationNo;
        this.quotationNoList.push(newItem);
      }
    }
  }*/
  //#endregion

  //#region 點Search按鈕
  async BtnSearch() {
    let MsgString = "";
    if (
      this.filterPricingDateFm != null &&
      this.filterPricingDateFm != "" &&
      this.filterPricingDateTo != null &&
      this.filterPricingDateTo != ""
    ) {
      if (this.filterPricingDateFm > this.filterPricingDateTo) {
        MsgString =
          "'Pricing date from' cannot be later than 'Pricing date to'.";
      }
    }
    if (
      this.filterModifiedDateFm != null &&
      this.filterModifiedDateFm != "" &&
      this.filterModifiedDateTo != null &&
      this.filterModifiedDateTo != "" &&
      MsgString == ""
    ) {
      if (this.filterModifiedDateFm > this.filterModifiedDateTo) {
        MsgString =
          "'Last Modified date from' cannot be later than 'Last Modified date to'.";
      }
    }
    if (
      this.filterCreationDateFm != null &&
      this.filterCreationDateFm != "" &&
      this.filterCreationDateTo != null &&
      this.filterCreationDateTo != "" &&
      MsgString == ""
    ) {
      if (this.filterCreationDateFm > this.filterCreationDateTo) {
        MsgString =
          "'Registration date from' cannot be later than 'Registration date to'.";
      }
    }
    if (MsgString != "") {
      this.ShowMessage(MsgString, "info");
    } else {
      this.isLoading = true;
      this.tableDatas = [];
      let pSoldToId = "",
        pQuotationNo = "",
        pCustomerName = "",
        pProjectNo = "",
        pQuoteStatus = "",
        pCyntecUser = "",
        pProductId = "",
        pIsValid = "",
        pPricinglDateFm = "",
        pPricingDateTo = "",
        pModifiedDateFm = "",
        pModifiedDateTo = "",
        pCreationDateFm = "",
        pCreationDateTo = "";
      if (this.filterSoldToId != null) {
        pSoldToId = "&SoldToId=" + this.filterSoldToId;
      }
      if (this.filterQuotationNo != null) {
        pQuotationNo = "&QuotationNo=" + this.filterQuotationNo;
      }
      if (this.filterCustomerName != null) {
        pCustomerName = "&CustomerName=" + this.filterCustomerName;
      }
      if (this.filterProjectNo != null) {
        pProjectNo = "&ProjectNo=" + this.filterProjectNo;
      }
      if (this.filterQuoteStatus != null) {
        pQuoteStatus = "&QuoteStatus=" + this.filterQuoteStatus;
      }
      if (this.filterCyntecUser != null) {
        pCyntecUser = "&CyntecUserId=" + this.filterCyntecUser;
      }
      if (this.filterIsValid != null) {
        pIsValid = "&IsValid=" + this.filterIsValid;
      }
      if (this.filterProductId != null) {
        pProductId = "&ProductId=" + this.filterProductId;
      }
      if (this.filterPricingDateFm != null) {
        pPricinglDateFm = "&PricingDateS=" + this.filterPricingDateFm;
      }
      if (this.filterPricingDateTo != null) {
        pPricingDateTo = "&PricingDateE=" + this.filterPricingDateTo;
      }
      if (this.filterModifiedDateFm != null) {
        pModifiedDateFm = "&ModifiedDateS=" + this.filterModifiedDateFm;
      }
      if (this.filterModifiedDateTo != null) {
        pModifiedDateTo = "&ModifiedDateE=" + this.filterModifiedDateTo;
      }
      if (this.filterCreationDateFm != null) {
        pCreationDateFm = "&CreationDateS=" + this.filterCreationDateFm;
      }
      if (this.filterCreationDateTo != null) {
        pCreationDateTo = "&CreationDateE=" + this.filterCreationDateTo;
      }

      let response;
      response = await AXIOS.get(
        Request,
        "/api/services/app/CynQuotations/GetCynQuotationsByUserId?" +
          pSoldToId +
          pQuotationNo +
          pCustomerName +
          pProjectNo +
          pQuoteStatus +
          pCyntecUser +
          pProductId +
          pIsValid +
          pPricinglDateFm +
          pPricingDateTo +
          pModifiedDateFm +
          pModifiedDateTo +
          pCreationDateFm +
          pCreationDateTo,
        null
      ).catch((error) => {
        if (error.response == null) {
          this.ShowMessage("CONNECTION ERROR", "info");
          this.isLoading = false;
        } else if (error.response.status == 401) {
          document.location.href = "../";
        }
      });

      if (response.data.success && response.data.result.items.length > 0) {
        for (let item of response.data.result.items) {
          let newItem: TableItem = new TableItem();
          newItem.Id = item.id;
          newItem.QuotationNo = item.quotationNo;
          newItem.ProjectNo = item.projectNo;
          newItem.SoldToId = item.soldToId;
          newItem.CustomerName = item.customerName;
          newItem.ProductId = item.productId;
          newItem.ProjectName = item.projectName;
          newItem.CreationTime = this.setDateFormat(item.creationTime);
          //newItem.PricingDate = this.setDateFormat(item.pricingDate);
          newItem.PricingDate =
            item.pricingDate == null || item.pricingDate == ""
              ? ""
              : this.setDateFormat(item.pricingDate);
          newItem.UnitPrice = item.unitPrice;
          newItem.QuoteStatusName = item.statusName;
          newItem.IsValid = item.isValid == "Y" ? "Valid" : "Invalid";
          this.tableDatas.push(newItem);
        }
      }
      this.isLoading = false;
    }
  }
  //#endregion

  //#region 點Refresh按鈕
  async BtnRefresh() {
    this.filterSoldToId = "";
    this.filterQuotationNo = "";
    this.filterCustomerName = "";
    this.filterProjectNo = "";
    this.filterQuoteStatus = "";
    this.filterCyntecUser = "";
    this.filterPricingDateFm = "";
    this.filterPricingDateTo = "";
    this.filterModifiedDateFm = "";
    this.filterModifiedDateTo = "";
    this.filterCreationDateFm = "";
    this.filterCreationDateTo = "";
    this.filterIsValid = "";
    this.filterProductId = "";
    this.SetTable();
  }
  //#endregion

  //#region 重設Create/Edit內容清單
  ReSetDialogForm(type: string) {
    if (type == "create") {
      //this.createProjectNoList = [];
      this.createProjectId = "";
      this.createProjectNo = "";
      this.createSoldToId = "";
      this.createProjectName = "";
      this.createSegName = "";
      this.createAppName = "";
      this.createMassProdPeriod = "";
      this.createCustomerName = "";
      this.createSubCustomerName = "";
      this.createEndCustomerName = "";
      this.createProductId = "";
      this.tableProductDatas = [];
      this.createDialog = false;
      this.btnToShow = true;
    } else {
      this.editId = 0;
      this.editQuotationNo = "";
      this.editProjectNo = "";
      this.editProjectName = "";
      this.editSoldToId = "";
      this.editSegName = "";
      this.editAppName = "";
      this.editMassProdPeriod = "";
      this.editCustomerName = "";
      this.editEndCustomerName = "";
      this.editSubCustomerName = "";
      this.editCyntecUserName = "";
      this.editProductId = "";
      this.editShow = false;

      this.editProducIndex = 0;
      this.editIndex = 0;
      this.editProductId = "";
      this.tableProductHeaders = [];
      this.tableProductDatas = [];
      this.editDialog = false;

      this.btnToShow = true;
    }
  }
  //#endregion

  //#region 取得Project的資料帶入至畫面中(create畫面)
  async GetProjectData() {
    this.isLoading = true;
    if (this.createProjectNo == "") {
      this.ShowMessage("Please select the [Project No].", "info");
    } else {
      let response;
      response = await AXIOS.get(
        Request,
        "api/services/app/CynProjects/GetCynProjectByUserId?projectNo=" +
          this.createProjectNo,
        null
      ).catch((error) => {
        if (error.response == null) {
          //console.log(error);
        } else if (error.response.status == 401) {
          document.location.href = "../";
        }
      });
      if (response.data.success) {
        let dataItem = response.data.result;
        this.createSoldToId = dataItem.soldToId;
        this.createProjectId = dataItem.id;
        this.createProjectName = dataItem.projectName;
        this.createSegName = dataItem.segName;
        this.createAppName = dataItem.appName;
        this.createMassProdPeriod = dataItem.massProdPeriod;
        this.createCustomerName = dataItem.customerName;
        this.createEndCustomerName = dataItem.endCustomerName;
        this.createSubCustomerName = dataItem.subCustomerName;
      }
      this.GetProductData();
      this.isLoading = false;
    }
  }
  //#endregion

  //#region 重新帶入Product資料(create畫面)
  async GetProductData() {
    this.isLoading = true;
    let response;
    this.tableProductDatas = [];
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetCynProjectLinesByUserId?projectId=" +
        this.createProjectId,
      null
    ).catch((error) => {
      if (error.response == null) {
        this.ShowMessage("CONNECTION ERROR", "info");
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success && response.data.result.items.length > 0) {
      let pIndex = 1;
      for (let dataItem of response.data.result.items) {
        let tableItem: ProductTableItem = new ProductTableItem();
        tableItem.Index = pIndex;
        tableItem.Id = 0;
        tableItem.ProductId = dataItem.productId;
        tableItem.Demand = dataItem.demand;
        tableItem.QuoteStatusName = "Request";
        tableItem.QuoteStatusId = "1";
        this.tableProductDatas.push(tableItem);
        pIndex++;
      }
    }
    this.isLoading = false;
  }
  //#endregion

  //#region GetProductDataOther(edit畫面)
  async GetProductDataEdit() {
    this.isLoading = true;

    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetCynProjectLinesOtherByUserId?quotationId=" +
        this.editId,
      null
    ).catch((error) => {
      if (error.response == null) {
        this.ShowMessage("CONNECTION ERROR", "info");
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });

    if (response.data.success && response.data.result.items.length > 0) {
      let pIndex = 1;
      let pExist = false;
      let tableProductDatasCopy = this.tableProductDatas;
      //this.tableProductDatas = [];
      if (tableProductDatasCopy.length > 0) {
        pIndex =
          tableProductDatasCopy[tableProductDatasCopy.length - 1].Index + 1;
      }
      for (let dataItem of response.data.result.items) {
        pExist = false;
        let tableItem: ProductTableItem = new ProductTableItem();
        for (let i = 0; i < tableProductDatasCopy.length; i++) {
          let pProductId = tableProductDatasCopy[i].ProductId;
          if (pProductId == dataItem.productId) {
            pExist = true;
          }
        }
        if (pExist == false) {
          tableItem.Index = pIndex;
          tableItem.Id = 0;
          tableItem.ProductId = dataItem.productId;
          tableItem.Demand = dataItem.demand;
          tableItem.SubmitDate = null;
          tableItem.QuoteStatusName = "Request";
          tableItem.QuoteStatusId = "1";
          this.tableProductDatas.push(tableItem);
          pIndex++;
        }
      }
    }
    this.isLoading = false;
  }
  //#endregion

  //#region 設定CreateOrEditFormList
  async GetCreateOrEditFormList() {
    //要設定ProjectNo List
    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetProjectListByUserId?Sorting=ProjectNo",
      null
    ).catch((error) => {
      if (error.response == null) {
        //console.log(error);
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success && response.data.result.items.length > 0) {
      for (let item of response.data.result.items) {
        let newItem: SelectItem = new SelectItem();
        newItem.text = item.projectNo;
        newItem.value = item.projectNo;
        this.createProjectNoList.push(newItem);
      }
    }
  }
  //#endregion

  //#region 修改資料的Form
  async EditDialogForm(item: any) {
    this.isLoading = true;
    this.RowDelet = [];
    this.editProductId = "";
    this.btnEditAddHidden = false;
    this.btnEditUpdateHidden = true;
    this.btnEditCancelHidden = true;
    this.editShow = false;

    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetCynQuotationByUserId?quotationNo=" +
        item.QuotationNo,
      null
    ).catch((error) => {
      if (error.response == null) {
        //console.log(error);
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success) {
      let dataItem = response.data.result;
      this.editId = dataItem.id;
      this.editQuotationNo = dataItem.quotationNo;
      this.editProjectNo = dataItem.projectNo;
      this.editProjectName = dataItem.projectName;
      this.editSoldToId = dataItem.soldToId;
      this.editSegName = dataItem.segName;
      this.editAppName = dataItem.appName;
      this.editMassProdPeriod = dataItem.massProdPeriod;
      this.editCustomerName = dataItem.customerName;
      this.editEndCustomerName = dataItem.endCustomerName;
      this.editSubCustomerName = dataItem.subCustomerName;
      this.editCyntecUserName = dataItem.cyntecUserName;
    }

    this.tableProductDatas = [];
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetCynQuotationLinesByUserId?quotationId=" +
        this.editId,
      null
    ).catch((error) => {
      if (error.response == null) {
        this.ShowMessage("CONNECTION ERROR", "info");
        this.isLoading = false;
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success && response.data.result.items.length > 0) {
      let pIndex = 1;
      for (let dataItem of response.data.result.items) {
        let newItem: ProductTableItem = new ProductTableItem();
        newItem.Index = pIndex;
        newItem.Id = dataItem.id;
        newItem.ProductId = dataItem.productId;
        newItem.Demand = dataItem.demand;
        newItem.UnitPrice = dataItem.unitPrice;
        newItem.ContractPrice = dataItem.contractPrice;
        newItem.CurrencyNo = dataItem.currencyNo;
        newItem.SPQ = dataItem.spq;
        newItem.MOQ = dataItem.moq;
        newItem.Leadtime = dataItem.leadtime;
        newItem.Validity = dataItem.validity;
        newItem.NCNR = dataItem.ncnr;
        newItem.Cancellation = dataItem.cancellation;
        newItem.SubmitDate = dataItem.submitDate;
        newItem.PricingDate =
          dataItem.pricingDate == null || dataItem.pricingDate == ""
            ? ""
            : this.setDateFormat(dataItem.pricingDate);
        newItem.QuoteStatusName = dataItem.statusName;
        newItem.QuoteStatusId = dataItem.status.toString();
        if (dataItem.status.toString() != "1") this.editShow = true;
        //newItem.IsValid = dataItem.isValid;
        newItem.IsValid = dataItem.isValid == "Y" ? "Valid" : "Invalid";
        if (
          dataItem.status.toString() == "3" &&
          dataItem.unitPrice != "" &&
          dataItem.unitPrice != null
        ) {
          newItem.Accept = "N";
        }
        newItem.IsUpdate = "N";
        this.tableProductDatas.push(newItem);
        pIndex++;
      }
    }
    if (this.editShow) {
      this.tableProductHeaders = this.tableEditProductHeaders;
    } else {
      this.tableProductHeaders = this.tableCreateProductHeaders;
    }
    this.isLoading = false;
  }
  //#endregion

  //#region 點選刪除Product Row資料
  DeleteProductRow(item: ProductTableItem) {
    let tableProductDatasCopy = this.tableProductDatas;
    this.tableProductDatas = [];
    for (let i = 0; i < tableProductDatasCopy.length; i++) {
      let pIndex: number = tableProductDatasCopy[i].Index;
      if (pIndex != item.Index) {
        let Item: ProductTableItem = tableProductDatasCopy[i];
        this.tableProductDatas.push(Item);
      } else {
        this.RowDelet.push(item.Id);
      }
    }
  }
  //#endregion

  //#region 點選Appept Row資料, 接受報價
  AcceptProductRow(item: ProductTableItem) {
    let tableProductDatasCopy = this.tableProductDatas;
    this.tableProductDatas = [];
    for (let i = 0; i < tableProductDatasCopy.length; i++) {
      let pIndex: number = tableProductDatasCopy[i].Index;
      let Item: ProductTableItem = tableProductDatasCopy[i];
      if (pIndex == item.Index) {
        if (Item.Accept == "Y") {
          Item.Accept = "N";
        } else {
          Item.Accept = "Y";
        }
      }
      this.tableProductDatas.push(Item);
    }
  }
  //#endregion

  //#region 新增資料
  async CreateData() {
    if (this.tableProductDatas.length == 0) {
      this.ShowMessage("Product is required field", "info");
    } else {
      if (this.createProjectId == "") {
        this.ShowMessage(
          "Please select the [Project No] and click the [Get Project Data] button to set the quote data.",
          "info"
        );
      } else {
        this.btnToShow = false;
        let formData = new FormData();
        for (let i = 0; i < this.tableProductDatas.length; i++) {
          let Item: ProductTableItem = this.tableProductDatas[i];
          formData.append("ProductId", Item.ProductId);
          formData.append("Demand", Item.Demand);
        }
        formData.append("ProjectNo", this.createProjectNo);
        formData.append("AddType", "Manual");

        let response;
        response = await AXIOS.post(
          Request,
          "api/services/app/CynQuotations/CreateOrEditFront",
          formData,
          null
        ).catch((error) => {
          if (error.response == null) {
            this.ShowMessage("CONNECTION ERROR", "info");
            this.btnToShow = true;
          } else if (error.response.status == 401) {
            document.location.href = "../";
          }
        });
        if (response.data.success) {
          this.BtnSearch();
          this.createDialog = false;
          this.ReSetDialogForm("create");
        } else {
          this.ShowMessage(response.data.result, "info");
          this.btnToShow = true;
        }
      }
    }
  }
  //#endregion

  //#region 更新資料
  async UpdateData() {
    if (this.tableProductDatas.length == 0) {
      this.ShowMessage("Product is required field", "info");
    } else {
      this.btnToShow = false;
      let formData = new FormData();
      for (let i = 0; i < this.tableProductDatas.length; i++) {
        let Item: ProductTableItem = this.tableProductDatas[i];
        //console.log(Item.ProductId == null ? "" : Item.ProductId);
        //formData.append("Id", Item.Id.toString());
        formData.append("ProductId", Item.ProductId);
        formData.append("Demand", Item.Demand);
        if (Item.QuoteStatusId == "3" && Item.Accept == "Y") {
          formData.append("IsUpdate", "Y");
        } else {
          formData.append("IsUpdate", "N");
        }
        if (Item.Accept == "Y") {
          formData.append("QuoteStatus", "4");
        } else {
          formData.append("QuoteStatus", Item.QuoteStatusId);
        }
        formData.append("ProductIndex", Item.Id.toString());
      }
      formData.append("Id", this.editId.toString());

      for (let i = 0; i < this.RowDelet.length; i++) {
        if (this.RowDelet[i].toString() != "0") {
          formData.append("DeleteProductIndex", this.RowDelet[i].toString());
        }
      }
      let response;
      response = await AXIOS.post(
        Request,
        "api/services/app/CynQuotations/CreateOrEditFront",
        formData,
        null
      ).catch((error) => {
        if (error.response == null) {
          this.ShowMessage("CONNECTION ERROR", "info");
          this.btnToShow = true;
        } else if (error.response.status == 401) {
          document.location.href = "../";
        }
      });
      if (response.data.success) {
        this.BtnSearch();
        this.editDialog = false;
        this.ReSetDialogForm("edit");
      } else {
        this.ShowMessage(response.data.result, "info");
      }
      this.btnToShow = true;
    }
  }
  //#endregion

  //#region 取得Headers
  SetHeaders() {
    let column: TableColumn = {
      text: "Action",
      value: "action",
      sortable: false,
      align: align.center,
    };

    let column1: TableColumn = {
      text: "Quotation No",
      value: "QuotationNo",
      sortable: true,
      align: align.center,
    };
    let column2: TableColumn = {
      text: "Project No",
      value: "ProjectNo",
      sortable: true,
      align: align.center,
    };
    let column3: TableColumn = {
      text: "Sold To ID",
      value: "soldToId",
      sortable: true,
      align: align.center,
    };
    let column4: TableColumn = {
      text: "Customer Name",
      value: "customerName",
      sortable: true,
      align: align.center,
    };
    let column5: TableColumn = {
      text: "Product ID",
      value: "productId",
      sortable: true,
      align: align.center,
    };
    let column6: TableColumn = {
      text: "Product Validity",
      value: "isValid",
      sortable: true,
      align: align.center,
    };
    let column7: TableColumn = {
      text: "Project Name",
      value: "projectName",
      sortable: true,
      align: align.center,
    };
    let column8: TableColumn = {
      text: "Creation Date",
      value: "creationTime",
      sortable: true,
      align: align.center,
    };
    let column9: TableColumn = {
      text: "Pricing Date",
      value: "pricingDate",
      sortable: true,
      align: align.center,
    };
    let column10: TableColumn = {
      text: "Unit Price",
      value: "unitPrice",
      sortable: true,
      align: align.center,
    };
    let column11: TableColumn = {
      text: "Quote Status",
      value: "quoteStatusName",
      sortable: true,
      align: align.center,
    };
    this.tableHeaders.push(column);
    this.tableHeaders.push(column1);
    this.tableHeaders.push(column2);
    this.tableHeaders.push(column3);
    this.tableHeaders.push(column4);
    this.tableHeaders.push(column5);
    this.tableHeaders.push(column6);
    this.tableHeaders.push(column7);
    this.tableHeaders.push(column8);
    this.tableHeaders.push(column9);
    this.tableHeaders.push(column10);
    this.tableHeaders.push(column11);
  }
  //#endregion

  //#region 取得Table資料
  async SetTable() {
    this.tableDatas = [];
    let response;
    response = await AXIOS.get(
      Request,
      "api/services/app/CynQuotations/GetCynQuotationsByUserId",
      null
    ).catch((error) => {
      if (error.response == null) {
        this.ShowMessage("CONNECTION ERROR", "info");
        this.isLoading = false;
      } else if (error.response.status == 401) {
        document.location.href = "../";
      }
    });
    if (response.data.success && response.data.result.items.length > 0) {
      for (let item of response.data.result.items) {
        let newItem: TableItem = new TableItem();
        newItem.Id = item.id;
        newItem.QuotationNo = item.quotationNo;
        newItem.ProjectNo = item.projectNo;
        newItem.SoldToId = item.soldToId;
        newItem.CustomerName = item.customerName;
        newItem.ProductId = item.productId;
        newItem.ProjectName = item.projectName;
        newItem.CreationTime =
          item.submitDate == null || item.submitDate == ""
            ? ""
            : this.setDateFormat(item.submitDate);
        //console.log(item.pricingDate);
        newItem.PricingDate =
          item.pricingDate == null || item.pricingDate == ""
            ? ""
            : this.setDateFormat(item.pricingDate);
        newItem.UnitPrice = item.unitPrice;
        newItem.QuoteStatusName = item.statusName;
        newItem.IsValid = item.isValid == "Y" ? "Valid" : "Invalid";
        this.tableDatas.push(newItem);
      }
    }
    this.isLoading = false;
  }
  //#endregion

  //#region 設定ProductHeaders
  SetProductHeaders() {
    let col_action: TableColumn = {
      text: "Action",
      value: "action",
      sortable: false,
      align: align.center,
    };
    let col_productId: TableColumn = {
      text: "Product ID",
      value: "productId",
      sortable: false,
      align: align.center,
    };
    let col_demand: TableColumn = {
      text: "Demand (pcs/mth)",
      value: "demand",
      sortable: false,
      align: align.center,
    };
    let col_pricingDate: TableColumn = {
      text: "Pricing Date",
      value: "pricingDate",
      sortable: false,
      align: align.center,
    };
    let col_unitPrice: TableColumn = {
      text: "Unit Price",
      value: "unitPrice",
      sortable: false,
      align: align.center,
    };
    let col_contractPrice: TableColumn = {
      text: "Contract Price",
      value: "contractPrice",
      sortable: false,
      align: align.center,
    };
    let col_currencyNo: TableColumn = {
      text: "Currency",
      value: "currencyNo",
      sortable: false,
      align: align.center,
    };
    let col_spq: TableColumn = {
      text: "SPQ",
      value: "spq",
      sortable: false,
      align: align.center,
    };
    let col_moq: TableColumn = {
      text: "MOQ",
      value: "moq",
      sortable: false,
      align: align.center,
    };
    let col_leadtime: TableColumn = {
      text: "Leadtime (Days)",
      value: "leadtime",
      sortable: false,
      align: align.center,
    };
    let col_validity: TableColumn = {
      text: "Validity Period (Days)",
      value: "validity",
      sortable: false,
      align: align.center,
    };
    let col_cancellation: TableColumn = {
      text: "Cancellation (Days)",
      value: "cancellation",
      sortable: false,
      align: align.center,
    };
    let col_ncnr: TableColumn = {
      text: "NCNR",
      value: "ncnr",
      sortable: false,
      align: align.center,
    };
    let col_quoteStatusName: TableColumn = {
      text: "Quote Status",
      value: "quoteStatusName",
      sortable: false,
      align: align.center,
    };
    let col_quoteAccept: TableColumn = {
      text: "",
      value: "accept",
      sortable: false,
      align: align.center,
    };
    let col_isValid: TableColumn = {
      text: "Validity",
      value: "isValid",
      sortable: false,
      align: align.center,
    };

    this.tableCreateProductHeaders.push(col_action);
    this.tableCreateProductHeaders.push(col_productId);
    this.tableCreateProductHeaders.push(col_demand);
    this.tableCreateProductHeaders.push(col_quoteStatusName);

    this.tableEditProductHeaders.push(col_action);
    this.tableEditProductHeaders.push(col_productId);
    this.tableEditProductHeaders.push(col_demand);
    this.tableEditProductHeaders.push(col_pricingDate);
    this.tableEditProductHeaders.push(col_unitPrice);
    this.tableEditProductHeaders.push(col_contractPrice);
    this.tableEditProductHeaders.push(col_currencyNo);
    this.tableEditProductHeaders.push(col_spq);
    this.tableEditProductHeaders.push(col_moq);
    this.tableEditProductHeaders.push(col_leadtime);
    this.tableEditProductHeaders.push(col_validity);
    this.tableEditProductHeaders.push(col_cancellation);
    this.tableEditProductHeaders.push(col_ncnr);
    this.tableEditProductHeaders.push(col_quoteStatusName);
    this.tableEditProductHeaders.push(col_quoteAccept);
    //this.tableEditProductHeaders.push(col_isValid);
  }
  //#endregion

  //#region ExportToExcel
  async ExportToExcel() {
    let MsgString = "";
    if (MsgString != "") {
      this.ShowMessage(
        MsgString + "\n(Export data based on search filters.)",
        "info"
      );
    } else {
      let formData = new FormData();
      if (this.filterSoldToId != null) {
        formData.append("SoldToId", this.filterSoldToId);
      }
      if (this.filterQuotationNo != null) {
        formData.append("QuotationNo", this.filterQuotationNo);
      }
      if (this.filterCustomerName != null) {
        formData.append("CustomerName", this.filterCustomerName);
      }
      if (this.filterProjectNo != null) {
        formData.append("ProjectNo", this.filterProjectNo);
      }
      if (this.filterQuoteStatus != null) {
        formData.append("QuoteStatus", this.filterQuoteStatus);
      }
      if (this.filterCyntecUser != null) {
        formData.append("CyntecUserId", this.filterCyntecUser);
      }
      if (this.filterIsValid != null) {
        formData.append("IsValid", this.filterIsValid);
      }
      if (this.filterProductId != null) {
        formData.append("ProductId", this.filterProductId);
      }
      if (this.filterPricingDateFm != null) {
        formData.append("PricingDateS", this.filterPricingDateFm);
      }
      if (this.filterPricingDateTo != null) {
        formData.append("PricingDateE", this.filterPricingDateTo);
      }
      if (this.filterModifiedDateFm != null) {
        formData.append("ModifiedDateS", this.filterModifiedDateFm);
      }
      if (this.filterModifiedDateTo != null) {
        formData.append("ModifiedDateE", this.filterModifiedDateTo);
      }
      if (this.filterCreationDateFm != null) {
        formData.append("CreationDateS", this.filterCreationDateFm);
      }
      if (this.filterCreationDateTo != null) {
        formData.append("CreationDateE", this.filterCreationDateTo);
      }

      let response;
      response = await AXIOS.post(
        Request,
        "api/services/app/CynQuotations/GetToExcelFront",
        formData,
        null
      ).catch((error) => {
        if (error.response == null) {
          this.ShowMessage("CONNECTION ERROR", "info");
        } else if (error.response.status == 401) {
          document.location.href = "../";
        }
      });
      let pRespnese: any = response.data.result.result;
      if (response.data.result.success) {
        this.ExportFile(pRespnese, "exportFile.xlsx");
      } else {
        this.ShowMessage("Export failed!", "info");
      }
    }
  }
  //#endregion

  //#region 下載Excel檔案
  ExportFile(fileContents: string, fileName: string) {
    var byteCharacters = atob(fileContents);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
      type: "data:application/vnd.ms-excel;base64,",
    });

    let link: HTMLAnchorElement = document.createElement("a");
    link.download = fileName;
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  //#endregion

  //#region 彈跳訊息顯示
  ShowMessage(msg: string, type: string) {
    this.infoString = msg;
    this.infoDialog = true;
  }
  //#endregion
}

class SelectItem {
  text: string;
  value: string;
  disabled: boolean;
  divider: boolean;
  header: string;
}

class TableItem {
  Id?: number = 0;
  QuotationNo = "";
  ProjectNo = "";
  SoldToId = "";
  CustomerName = "";
  ProjectName = "";
  ProductId = "";
  CreationTime = "";
  PricingDate = "";
  UnitPrice = "";
  QuoteStatusName = "";
  IsValid = "";
}

class ProductTableItem {
  Index = 0;
  Id?: number = 0;
  ProductId = "";
  Demand = "";
  UnitPrice = "";
  ContractPrice = "";
  CurrencyNo = "";
  SPQ = "";
  MOQ = "";
  Leadtime = "";
  Validity = "";
  NCNR = "";
  Cancellation = "";
  SubmitDate = "";
  PricingDate = "";
  QuoteStatusName = "";
  QuoteStatusId = "";
  IsValid = "";
  Accept = "";
  IsUpdate = "";
}

class TableColumn {
  text = "";
  value = "";
  align?: align | null = undefined;
  sortable?: boolean | null = undefined;
  filterable?: boolean = undefined;
  groupable?: boolean = undefined;
  divider?: boolean = undefined;
  class?: string | string[] = undefined;
  cellClass?: string | string[] = undefined;
  width?: string | number = undefined;
  filter?: (value: any, search: string, item: any) => boolean;
  sort?: (a: any, b: any) => number;
}

enum align {
  start = "string",
  center = "center",
  end = "end",
  left = "left",
  right = "right",
}
